import FormProv from './FormProv/FormProv'
import FormTrab from './FormTrab/FormTrab';
export const FormProvPage = FormProv
export const FormTrabPage = FormTrab
